import Chart from 'chart.js/auto';

class BarChart extends HTMLCanvasElement {

    constructor() {
        super();
        this.chart = null;
    }

    connectedCallback() {
        this.renderChart();
    }

    disconnectedCallback() {
        if (this.chart) {
            this.chart.destroy();
        }
    }

    renderChart() {
        const ctx = this.getContext('2d');

        const data = JSON.parse(this.getAttribute('data-values'));
        const displayX = this.getAttribute('data-display-x');
        const displayColumnValue = this.getAttribute('data-display-column-value');

        const keys = Object.keys(data);
        const abscisses = Object.keys(data[keys[0]].values);
        const datasets = [];

        $(Object.keys(data)).each(function (index, key) {
            let dataset = {
                label: data[key].label,
                data: Object.values(data[key].values),
                backgroundColor : []
            };

            $(abscisses).each(function (i, e) {
                dataset.backgroundColor.push(data[key].color);
            });

            datasets.push(dataset);
        });

        const options = {
            plugins: {
                legend: {
                    display: false
                }
            }
        };

        // Options spécifiques pour bar-evol
        if (this.classList.contains('bar-evol')) {
            this.style.height = '300px';
            options.maintainAspectRatio = false;
            options.responsive = true;
            options.plugins.legend = {
                display: true,
                position: 'right',
                align: 'center',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    font: {
                        weight: 'bold'
                    }
                }
            };
            // Ajout des options similaires à bar-sav
            options.scales = {
                y: {
                    beginAtZero: true,
                    ticks: {
                        padding: 5
                    },
                    grid: {
                        drawBorder: false
                    }
                }
            };
            options.layout = {
                padding: {
                    top: 20
                }
            };
            options.elements = {
                bar: {
                    borderRadius: {
                        topLeft: 4,
                        topRight: 4,
                        bottomLeft: 0,
                        bottomRight: 0
                    },
                    borderSkipped: false
                }
            };
        }

        // Options spécifiques pour bar-sav
        if (this.classList.contains('bar-sav')) {
            options.plugins.legend = {
                display: true,
                position: 'bottom',
                align: 'center',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    font: {
                        weight: 'bold'
                    }
                }
            };
            options.scales = {
                y: {
                    beginAtZero: true,
                    ticks: {
                        padding: 5
                    },
                    grid: {
                        drawBorder: false
                    }
                }
            };
            options.layout = {
                padding: {
                    top: 20 // Ajoute de l'espace en haut pour le texte
                }
            };
            options.elements = {
                bar: {
                    borderRadius: {
                        topLeft: 4,
                        topRight: 4,
                        bottomLeft: 0,
                        bottomRight: 0
                    },
                    borderSkipped: false
                }
            };
        }

        if (displayX == "false") {
            options.scales = {
                x: {
                    display: false
                }
            };
        }

        // Plugin pour afficher les valeurs
        const valueLabelPlugin = {
            id: 'valueLabel',
            afterDatasetsDraw(chart) {
                const { ctx } = chart;

                ctx.save();
                ctx.font = 'bold 12px Arial';
                ctx.fillStyle = '#666';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'bottom';

                chart.data.datasets.forEach((dataset, i) => {
                    chart.getDatasetMeta(i).data.forEach((bar, index) => {
                        const value = dataset.data[index];
                        const x = bar.x;
                        const y = bar.y - 5;

                        // Ajoute le 'T' uniquement pour bar-evol avec 2 décimales
                        const displayValue = chart.canvas.classList.contains('bar-evol') 
                            ? `${Number(value).toFixed(2)}T` 
                            : value;
                        ctx.fillText(displayValue, x, y);
                    });
                });

                ctx.restore();
            }
        };

        // Ajout du plugin dans les options
        options.plugins.valueLabel = valueLabelPlugin;

        this.chart = new Chart(ctx, {
            plugins: [valueLabelPlugin],
            type: 'bar',
            data: {
                labels: abscisses,
                datasets: datasets
            },
            options: options
        });
    }
}

export default BarChart;
